var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-param-reassign */
import React from 'react';
import cn from 'classnames';
import styles from 'core-components/src/components/navbar/navbar.scss';
export const NavBar = (props) => {
    const { children, color, className } = props, nativeProps = __rest(props, ["children", "color", "className"]);
    const wrapperStyles = cn({
        [styles.navbar]: true,
        [className]: className
    });
    return (React.createElement("nav", Object.assign({}, nativeProps, { className: wrapperStyles }),
        React.createElement("header", { className: styles.container }, children)));
};
